<template>
  <div id="member_detail_outer" v-if="user != null" >
    <img id="user_img" :src="headImage">
    <div class="user-text-blod">{{nickName}}</div>
    <div v-if="user.enterprise != null && user.enterprise != ''" class="user-text-blod">{{user.enterprise}}</div>
    <div id="user_address" class="user-text-normal" v-if="userAddress != null">{{userAddress}}</div>
    <div class="user-text-blod" v-if="userDesc != null">{{user.isTeam == 0 ? '个人简介：' : '团体简介：'}}</div>
    <div id="user_profile"  v-if="userDesc != null" class="user-text-normal" v-html="userDesc" />
<!--    <div id="user_profile"  v-if="userDesc != null" class="user-text-normal" >{{userDesc}}</div>-->
    <div class="user-text-blod">会员证书：</div>
    <img id="user_basket_certificate" v-if="certificateUrl != null" :src="certificateUrl" style="width: 70%;">
    <div v-if="user.professionalCertificate  != null && user.professionalCertificate.length > 0" class="user-text-blod" style="margin-top: 30px;">职业证书：</div>
    <img v-if="user.professionalCertificate  != null && user.professionalCertificate.length > 0" v-for="item in user.certificateList" :src="user.professionalCertificate " style="width: 70%;margin-top: 20px;">

  </div>
</template>

<script>
import DefaultUserHeadImage from '../../assets/shl_personal_head_portrait_gold_default.png';
import DefaultMemberHeadImage from '../../assets/shl_group_head_portrait_gold_default.png';
export default {
  name: "MemberDetail",
  data() {
    return {
      title: '会员详情页',
      user: null,
      certificateUrl: null
    }
  },
  computed: {
    userId() {
      let userId = this.$route.params.userId;
      return userId;
    },
    nickName() {
      let name = this.user.name;
      if (name == null || name.length == 0) {
        return this.user.nickname;
      }
      return name;
    },

    certificateDefaultImage() {
      return this.user.isTeam == 1 ? DefaultMemberHeadImage : DefaultUserHeadImage;
    },

    headImage() {
      let headImage = this.user.headPortrait;
      if (headImage == null || headImage == '') {
        return this.certificateDefaultImage;
      }
      return headImage;
    },
    userAddress() {
      let area = this.user.area;
      if (area == null) {
        return null;
      }
      return area;
    },
    userDesc() {
      let desc = this.user.desc;
      if (desc == null || desc.length == 0) {
        return null;
      }
      return desc;
    },
    canvasVailidDateText() {
      let validDate = this.$moment(this.user.memberValidDate);
      if (validDate.isValid()) {
        let issueDate = validDate.add('-1', 'years');
        return issueDate.format('YYYY.MM.DD') + ' ~ ' + validDate.format('YYYY.MM.DD');;
      }
      return '';
    },
    issueDate() {
      let validDate = this.$moment(this.user.memberValidDate);
      if (validDate.isValid()) {
        let issueDate = validDate.add('-1', 'years');
        return issueDate.format('YYYY.MM.DD');
      }
      return  '';
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {

      let userId = this.userId;
      if (userId == null || userId == undefined) {
        return;
      }
      let params = {
        userId,
      };
      let _this = this;
      this.$store.state.http.ajax.userGet(params, function (data) {
        console.log(data);
        let code = data.code;
        if (code == 0) {
          _this.user = data.data;
          _this.drawCertificateImages();
          _this.dealWithShareObj();

        } else {
          _this.$toast('加载失败！');
        }
      }, function (data) {
          _this.$toast('请求失败，请刷新页面！');
      })
    },

    dealWithShareObj() {
      let shareObj = this.$store.state.http.defaultShareObj;
      shareObj.title = this.user.name + ' 会员证书'
      shareObj.link = location.href;
      let imgUrl = this.user.headPortrait;
      if (imgUrl != null && imgUrl != '') {
        shareObj.imgUrl = imgUrl;
      }
      this.configShareWx(encodeURIComponent(location.href), shareObj);
    },
    drawCertificateImages() {
      let _this = this;
      this.drawCertificateImage(this.user, function (image) {
        _this.certificateUrl = image;
      })
    },
  }
}
</script>

<style scoped>

  #member_detail_outer {
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
  }

  #user_img {
    width: 100px;
    border-radius: 50px;
    border: solid 1px #cbb042;
  }

  .user-text-blod {
    font-size: 1.5rem;
    font-weight: bold;
    color: #333;
    margin-top: 20px;

  }
  .user-text-normal {
    font-size: 1rem;
    color: #666;
  }

  #user_address {
    margin-top: 10px;
  }

  #user_profile {
    margin-top: 15px;
  }

  #user_basket_certificate {
    margin-top: 15px;
  }


</style>



// WEBPACK FOOTER //
// src/components/introduce/MemberDetail.vue